import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import userLogin from "./userlogin";
import codeLogin from "./codelogin";
import thirdLogin from "./thirdlogin";
import { mapGetters } from "vuex";
import { dateFormat } from "@/util/date";
import { validatenull } from "@/util/validate";
import topLang from "@/page/index/top/top-lang";
import topColor from "@/page/index/top/top-color";
import { getQueryString, getTopUrl } from "@/util/util";
export default {
  name: "login",
  components: {
    userLogin: userLogin,
    codeLogin: codeLogin,
    thirdLogin: thirdLogin,
    topLang: topLang,
    topColor: topColor
  },
  data: function data() {
    return {
      time: "",
      logo: require('@/assets/logo.png'),
      title: '',
      info: '',
      activeName: "user",
      socialForm: {
        tenantId: "",
        source: "",
        code: "",
        state: ""
      }
    };
  },
  watch: {
    $route: function $route() {
      this.handleLogin();
    }
  },
  created: function created() {
    this.handleLogin();
    this.getTime();
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters(["website", "tagWel"])),
  props: [],
  methods: {
    getTime: function getTime() {
      var _this = this;

      setInterval(function () {
        _this.time = dateFormat(new Date());
      }, 1000);
    },
    handleLogin: function handleLogin() {
      var _this2 = this;

      var topUrl = getTopUrl();
      var redirectUrl = "/oauth/redirect/";
      this.socialForm.source = getQueryString("source");
      this.socialForm.code = getQueryString("code");
      this.socialForm.state = getQueryString("state");

      if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
        var source = topUrl.split("?")[0];
        source = source.split(redirectUrl)[1];
        this.socialForm.source = source;
      }

      if (!validatenull(this.socialForm.source) && !validatenull(this.socialForm.code) && !validatenull(this.socialForm.state)) {
        var loading = this.$loading({
          lock: true,
          text: '第三方系统登录中,请稍后。。。',
          spinner: "el-icon-loading"
        });
        this.$store.dispatch("LoginBySocial", this.socialForm).then(function () {
          window.location.href = topUrl.split(redirectUrl)[0];

          _this2.$router.push({
            path: _this2.tagWel.value
          });

          loading.close();
        }).catch(function () {
          loading.close();
        });
      }
    }
  }
};